import type CurrencyCode from '@alltrails/types/CurrencyCode';

// TikTok Pixel
// https://ads.tiktok.com/help/article/get-started-pixel?lang=en

export const trackPurchaseForTikTok = ({
  userId,
  recurlyPlanCode,
  currencyCode,
  value
}: {
  userId: number;
  recurlyPlanCode: string;
  currencyCode: CurrencyCode;
  value: number;
}) => {
  if (isTikTokPixelUnavailable()) {
    return;
  }

  if (userId) {
    ttq.identify({
      external_id: userId
    });
  }

  ttq.track('CompletePayment', {
    content_type: 'product',
    description: 'Pro Subscription',
    quantity: 1,
    content_id: recurlyPlanCode,
    currency: currencyCode,
    value
  });
};

// Check for presence of ttq in case of content blockers
const isTikTokPixelUnavailable = () => {
  return typeof ttq === 'undefined';
};
